import { useFormikContext, ErrorMessage } from 'formik';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AvailabilityModel } from '../../../models/AvailabilityModel';
import { ProductModel } from '../models/ProductModel';
import { CascadeEntitySelections } from './CascadeEntitySelection';
interface Props {
  product: ProductModel;
}

export function ProductAvailabilityStep4({ product }: Props) {
  const [list, setList] = useState<AvailabilityModel[]>(product.availabilities);
  const { setFieldValue } = useFormikContext();
  const handleAddItem = () => {
    if (!product.cascadeselects?.accountId) {
      return toast.warning('You must select an account');
    }
    if (product.cascadeselects) {
      setList([...list, product.cascadeselects]);
    }
  };
  const handleRemoveItem = (idx: number) => {
    const items = list;
    if (items.length > 0) {
      setList(items.filter((item, index) => index !== idx));
    }
  };
  useEffect(() => {
    setFieldValue('availabilities', list);
  }, [list, setFieldValue]);

  return (
    <div style={{ width: '100%' }}>
      <div className='row'>
        <div style={{ width: 'calc( 100% - 100px )' }}>
          <CascadeEntitySelections id={product.id} />
        </div>
        <div className='w-100px'>
          <div className='text-end'>
            <button
              onClick={handleAddItem}
              type='button'
              className='btn btn-primary mt-7 p-3'
            >
              <i className='las la-plus fs-2'></i>Add
            </button>
          </div>
        </div>
      </div>
      <div className='row mt-5'>
        <div className='col-12'>
          <ErrorMessage name='availabilities'>
            {(msg) => <div className='text-danger'>{msg}</div>}
          </ErrorMessage>
        </div>
      </div>
      <div className='table-responsive mt-10'>
        <table className='table table-row-dashed table-row-gray-300 align-middle g-4'>
          <thead>
            <tr className='fw-bolder text-muted'>
              <th className='min-w-150px'>Account</th>
              <th className='min-w-150px'>Client</th>
              <th className='min-w-150px'>Franchise</th>
              <th className='min-w-150px'>Locations</th>
            </tr>
          </thead>
          <tbody className='border-0'>
            {list.map((x, index) => {
              return (
                <tr key={`availabilities.${index}`}>
                  <td>{x.accountId ? x.accountName : 'All'}</td>
                  <td>{x.clientId ? x.clientName : 'All'}</td>
                  <td>{x.franchiseId ? x.franchiseName : 'All'}</td>
                  <td>{x.locationId ? x.locationName : 'All'}</td>
                  <td>
                    <button
                      onClick={() => {
                        handleRemoveItem(index);
                      }}
                      type='button'
                      id='buton-delete'
                      className='btn btn-active-danger p-3'
                    >
                      <i className='las la-times fs-2'></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
